import React from 'react';
import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";


export default function GenerateDialog (props){

    const { showDialog, handleCloseDialog, classes, polling, reportRequest, error, downloadUrl, title, hideDelayMessage } = props;


    return (
        <Dialog
            disableBackdropClick
            disableEscapeKeyDown
            open={showDialog}
            onClose={handleCloseDialog}
            maxWidth="xl"
            PaperProps={{className: classes.dialog}}
            >
            <DialogTitle>
                <Box style={{verticalAlign: 'middle'}}>{ !!title ? {title} : 'Report generation' }</Box>
                <IconButton onClick={handleCloseDialog} disabled={polling} className={classes.close}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContainer}>

                <Box>
                    <Box my={2}>
                        <Box p={1} className={classes.wrapper}>

                            {polling && <CircularProgress style={{verticalAlign: "middle", marginLeft: 5}} color="primary" size={28} />}
                            <Box style={{verticalAlign: 'left'}} component="span" mx={1}>
                                Status:
                            </Box>
                            <Box style={{verticalAlign: 'middle'}} component="span" mx={1}>
                                {reportRequest.status}
                            </Box>
                            {!!reportRequest.url && (
                                <Box onClick={(e) => downloadUrl(reportRequest.id, e)} style={{verticalAlign: 'middle'}} component="a" href="#" mx={1}>
                                    Download
                                </Box>
                            )}
                            {reportRequest.count >= 0 && (
                                <Box style={{verticalAlign: 'middle'}} component="span" mx={1}>
                                    <em>{reportRequest.count} rows</em>
                                </Box>
                            )}
                        </Box>

                            <Box mt={1}>
                                <small><em>
                                    Processing report will take several minutes depend on number of rows. <br/>
                                    Please be patient and do not close the popup or refresh page.</em>
                                    <br/>
                                    <br/>
                                    {!hideDelayMessage &&
                                    <b>Data from reports may be delayed by up 60 minutes</b>
                                    }
                                </small>
                            </Box>

                    </Box>
                {error && <Box p={1} className={classes.error}>{error}</Box>}
                </Box>
            </DialogContent>
        </Dialog>        
    )    
}